export default "__VITE_ASSET__baf65173__"